

import React, { Component } from 'react';
import cx from 'classnames';
import Text from '../../Text';
import '../styles/_loader.scss';













// 1.5s
const LOADER_INITIAL_TIMEOUT = 1500;
const LOADER_TEXT_TIMEOUT = 3000;

export default class Loader extends Component {




  constructor() {
    super();

    this.state = {
      showLoader: false
    };
  }

  componentDidMount() {
    const { hasNoBeforeShowTimeout } = this.props;

    if (hasNoBeforeShowTimeout) {
      this.showLoader();
      this.showText();
      return;
    }

    this._timeout = setTimeout(
      this.showLoader,
      LOADER_INITIAL_TIMEOUT
    );
    this._textTimeout = setTimeout(
      this.showText,
      LOADER_TEXT_TIMEOUT
    );
  }

  componentWillUnmount() {
    /* istanbul ignore else */
    if (this._timeout) {
      clearTimeout(this._timeout);
    }

    /* istanbul ignore else */
    if (this._textTimeout) {
      clearTimeout(this._textTimeout);
    }
  }

  showLoader = () => {
    this._timeout = null;

    this.setState({ showLoader: true });
  };

  showText = () => {
    this._textTimeout = null;

    this.setState({ showText: true });
  };

  render() {
    const {
      text = 'Give us a few moments to fetch this for you.',
      caption = null,
      darkTheme
    } = this.props;

    const { showLoader, showText } = this.state;

    if (!showLoader) {return null;}

    return (
      <div className={cx('loader', { 'loader--dark-theme': darkTheme })}>
        <div className="loader__spinner">
          <div className="loader__spinner__bounce1" />
          <div className="loader__spinner__bounce2" />
          <div className="loader__spinner__bounce3" />
        </div>
        {
        showText &&
        <>
              {text && <Text className="loader__title" heading3 centered noMargin="top">{text}</Text>}
              {caption && <Text className="loader__caption" noMargin centered placeholder>{caption}</Text>}
            </>}


      </div>);

  }
}